import { createSlice } from "@reduxjs/toolkit";
import { SORT_ORDERS, ROUTE_SORT_TYPES } from "../../consts/sorters";

const initialState = {
  sortOrder: SORT_ORDERS.DESC,
  sortType: ROUTE_SORT_TYPES.ROUTE_NUMBER,
};

export const sortersSlice = createSlice({
  name: "sorters",
  initialState,
  reducers: {
    resetSort: () => initialState,
    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
    setSortType: (state, action) => {
      state.sortType = action.payload;
    },
  },
});

const { actions, reducer } = sortersSlice;
const { resetSort, setSortOrder, setSortType } = actions;
export { reducer, resetSort, setSortOrder, setSortType };
